'use client';

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCaplightPricing } from 'services/offerings';
import type { CaplightOfferingData } from 'services/offerings';

const useGetCaplightPricing = (offeringIds: string[], isAuthenticated = true) => {
  const sortedIds = useMemo(() => [...offeringIds].sort(), [offeringIds]);

  const { data, isLoading } = useQuery({
    queryKey: ['caplightPricing', sortedIds],
    queryFn: () => getCaplightPricing(sortedIds),
    enabled: sortedIds.length > 0 && isAuthenticated === true,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const pricingMap = useMemo(() => {
    const map = new Map<string, CaplightOfferingData>();
    if (data?.offerings) {
      for (const item of data.offerings) {
        map.set(item.offeringId, item);
      }
    }
    return map;
  }, [data]);

  return { pricingMap, isLoading };
};

export default useGetCaplightPricing;
